<main class="container-fluid">
    <section class="sec-main p-0 m-0">
        <div class="row">
            <div class="col-sm-6 p-5 d-flex">
                <div class="container p-3">
                            <div class="back-button">
                                <a href="" class="back-button-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7062 8.11538C15.095 7.72569 15.0947 7.09466 14.7054 6.70538C14.3158 6.31581 13.6842 6.31581 13.2946 6.70538L8.70711 11.2929C8.31658 11.6834 8.31658 12.3166 8.70711 12.7071L13.2946 17.2946C13.6842 17.6842 14.3158 17.6842 14.7054 17.2946C15.0947 16.9053 15.095 16.2743 14.7062 15.8846L10.83 12L14.7062 8.11538Z" fill="black" fill-opacity="0.5"/>
                                        </svg>
                                    Back
                                </a>
                            </div>
                            <h2 class="support">How can we support you ?</h2>
                            <div class="support-info">We're here to assist you with any questions, concerns, or feedback you may have. Our dedicated team is committed to providing you with the best possible assistance to ensure you a smooth experience with Data On Demand.</div>
                            <div class="assistance-text">For general inquiries, assistance, or feedback, email us at: </div>
                                <div><a href="mailto:support.dataondemand@tatasteeleurope.com" class="link">support.dataondemand&#64;tatasteeleurope.com</a></div>
                        </div>
                    </div>
            <div class="col-sm-6 support-pic"></div>
        </div>
    </section>
</main>
